import { Pipe, PipeTransform } from '@angular/core';

/**
 * Usefull to compare that given language code is null or equals default language code.
 */
@Pipe({
  name: 'isNullOrEquals'
})
export class IsNullOrEqualsPipe implements PipeTransform {

  public transform(mainValue: string|null, otherValue: string): boolean {
    return !mainValue || !otherValue || (mainValue.toLowerCase() === otherValue.toLowerCase());
  }

}
